module.exports = __webpack_public_path__ + "static/media/icon-tag-moduleF5.db388e28.png";